import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { autobind } from 'core-decorators'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'
import { StickyContainer, Sticky } from 'react-sticky'
import 'bootstrap/dist/css/bootstrap.min.css'
import './all.scss'
import 'animate.css/animate.min.css'
import '../../../static/css/fonts.css'
import Header from './header'
import Footer from './footer'
import { observer, inject } from 'mobx-react'
import { BaseCSS } from 'styled-bootstrap-grid'
import { initGA } from 'utils/analytics'
import { GG_ANALYTIC_ID } from 'config'

initGA()

const LayoutStyle = styled(StickyContainer)``

const HeaderContainer = styled.div`
  position: relative;
  z-index: 1050;
`

export default
@inject('authStore', 'paymentStore', 'localeStore')
@observer
@autobind
class Layout extends Component {
  static propTypes = {
    // Page Info
    title: PropTypes.string,
    // Header
    headerMode: PropTypes.oneOf(['dark', 'light']),
    headerBG: PropTypes.bool,
    // Footer
    footerBG: PropTypes.bool
  }

  static defaultProps = {
    // Page Info
    title: 'Tungtung Community',
    // Header
    headerMode: 'light',
    headerBG: true,
    // Footer
    footerBG: true
  }

  componentDidMount () {
    const WOW = require('wowjs')
    const wow = new WOW.WOW()
    wow.init()
    this.props.authStore.fetchMe()
    this.props.paymentStore.fetchPlans()
    this.props.localeStore.init()
  }

  render () {
    const { title, headerMode, headerBG, footerBG, authStore } = this.props
    if (authStore.isFetchingMe) return null
    return (
      <LayoutStyle>
        <Helmet
          htmlAttributes={{
            lang: 'vi'
          }}
        >
          <title>{title} - tungtung.vn</title>
          <meta
            name='description'
            content='Tungtung là nền tảng đề thi trực tuyến giúp mọi cá nhân chia sẻ và phát triển kiến thức của mình.'
          />
          <meta charset='utf-8' />
          <meta http-equiv='X-UA-Compatible' content='IE=edge' />
          <meta
            name='viewport'
            content='width=device-width, initial-scale=1, shrink-to-fit=no'
          />
          <meta property='fb:app_id' content={GG_ANALYTIC_ID} />
          <meta property='og:type' content='website' />
          <meta property='og:title' content='tungtung.vn - Nền Tảng Đánh Giá Năng Lực Toàn Cầu' />
          <meta property='og:description' content='Tungtung là nền tảng đề thi trực tuyến giúp mọi cá nhân chia sẻ và phát triển kiến thức của mình.' />
          <meta property='og:image' content='/img/tt-og-image.png' />
          <meta property='og:image:width' content='1200' />
          <meta property='og:image:height' content='630' />
          <link rel='shortcut icon' href='/img/logo-icon.png' />
          <link rel='apple-touch-icon' href='/img/tungtung-icon.png' />
          <link
            rel='stylesheet'
            href='/css/style.css'
          />
          <link
            rel='stylesheet'
            href='/css/style-custom.css'
          />
          <link rel='stylesheet' href='/css/driver.min.css' />
          <link rel='stylesheet' href='/css/fonts.css' />
          <script
            async
            src='https://www.googletagmanager.com/gtag/js?id=UA-125809491-3'
          />
          <link
            rel='stylesheet'
            href='https://use.fontawesome.com/releases/v5.8.1/css/all.css'
            integrity='sha384-50oBUHEmvpQ+1lW4y57PTFmhCaXp0ML5d60M1M7uH2+nqUivzIebhndOJK28anvf'
            crossorigin='anonymous'
          />
        </Helmet>
        <BaseCSS />
        <Sticky topOffset={8}>
          {({ style, isSticky }) => (
            <HeaderContainer style={style}>
              <Header isSticky={isSticky} mode={headerMode} bg={headerBG} />
            </HeaderContainer>
          )}
        </Sticky>
        {this.props.children}
        <Footer bg={footerBG} />
      </LayoutStyle>
    )
  }
}
